<template>
	<div>
		<!-- =========== Start of Body ============ -->
		<section
			class="bg-color--dark--1 h-min-100vh d-flex align-items-centerv mt-4 pb-5"
		>
			<div class="svg-shape--top w-100 opacity--05">
				<img src="/assets/img/wave-8.svg" alt="wave" class="svg fill--white" />
			</div>
			<!-- end of whole area svg bg -->
			<div class="svg-shape--top opacity--10">
				<img src="assets/img/wave-9.svg" alt="wave" class="svg fill--white" />
			</div>
			<div class="container">
				<div class="row">
					<div
						class="col-12 mx-auto color--white text-center mb-2 mb-lg-2 pt-6"
					>
						<h3 class="mb-1 text-white">
							اطلاعات تکمیلی
						</h3>
					</div>
					<div class="col-12 col-sm-10 col-md-8 col-lg-9 col-xl-9 mx-auto">
						<div
							class="form--v5 px-3 py-4 px-md-5 py-md-6 rounded--10 bg-color--light--1"
						>
							<form class="form">
								<div
									class="alert alert-danger"
									role="alert"
									id="alert"
									v-show="alert"
								>
									<ul>
										<li v-for="err in errors" :key="err">
											{{ err[0] }}
										</li>
									</ul>
								</div>
								<div class="container">
									<!-- NAME & LAST NAME -->
									<div class="row justify-content-between">
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.name") }}</label
												>
												<input
													id="name"
													type="text"
													v-model.trim="$v.name.$model"
													class="form-control form-control-sm"
													:class="{ 'is-invalid': $v.name.$error }"
													@blur="$v.name.$touch()"
												/>
												<div class="invalid-feedback" v-if="!$v.name.required">
													ورود نام لازم است
												</div>
											</div>
										</div>

										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.lastName") }}</label
												>
												<input
													id="lastName"
													type="text"
													v-model.trim="$v.lastName.$model"
													class="form-control"
													:class="{ 'is-invalid': $v.lastName.$error }"
													@blur="$v.lastName.$touch()"
												/>
												<div
													class="invalid-feedback"
													v-if="!$v.lastName.required"
												>
													ورود نام خانوادگی لازم است
												</div>
											</div>
										</div>
									</div>

									<!-- FATHERNAME & Phone -->
									<div class="row justify-content-between">
										<!-- FATHERNAME &  -->
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.fatherName") }}</label
												>
												<input
													id="fatherName"
													type="text"
													v-model.trim="$v.fatherName.$model"
													class="form-control"
													:class="{ 'is-invalid': $v.fatherName.$error }"
													@blur="$v.fatherName.$touch()"
												/>
												<div
													class="invalid-feedback"
													v-if="!$v.fatherName.required"
												>
													ورود نام پدر الازمی است
												</div>
											</div>
										</div>
										<!-- Melli Code -->
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.melliCode") }}</label
												>
												<input
													id="melliCode"
													type="number"
													@wheel="$event.target.blur()"
													v-model.trim="$v.melliCode.$model"
													class="form-control"
													:class="{ 'is-invalid': $v.melliCode.$error }"
													@blur="$v.melliCode.$touch()"
												/>
											</div>
											<div
												class="invalid-feedback"
												v-if="!$v.melliCode.checkMelliCode"
											>
												کد ملی معتبر نیست
											</div>
										</div>
									</div>

									<!-- PHONE NUMBER & Gender -->
									<div class="row justify-content-between">
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.phone") }}</label
												>
												<input
													id="phone"
													type="number"
													@wheel="$event.target.blur()"
													v-model.trim="$v.phone.$model"
													class="form-control"
													:class="{ 'is-invalid': $v.phone.$error }"
													@blur="$v.phone.$touch()"
												/>
												<div class="invalid-feedback" v-if="!$v.phone.required">
													ورود تلفن لازم است
												</div>
												<div
													class="invalid-feedback"
													v-if="!$v.phone.minLength || !$v.phone.maxLength"
												>
													شماره تلفن نا معتبر است
												</div>
											</div>
										</div>
										<!--Gender -->
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase form-check-inline form-check-label font-size--15 font-w--500"
													>{{ $t("register.gender") }}</label
												>

												<div class="form-check form-check-inline mt-2">
													<input
														id="gender"
														class="form-check-input"
														type="radio"
														name="inlineRadioOptions"
														value="m"
														v-model.trim="$v.gender.$model"
														:class="{ 'is-invalid': $v.gender.$error }"
														@blur="$v.gender.$touch()"
													/>
													<label
														class="form-check-label"
														for="inlineRadioMan"
														>{{ $t("register.male") }}</label
													>
												</div>
												<div class="form-check form-check-inline">
													<input
														class="form-check-input"
														type="radio"
														name="inlineRadioOptions"
														id="inlineRadioWoman"
														value="f"
														v-model.trim="$v.gender.$model"
														:class="{ 'is-invalid': $v.gender.$error }"
														@blur="$v.gender.$touch()"
													/>
													<label
														class="form-check-label"
														for="inlineRadioWoman"
														>{{ $t("register.female") }}</label
													>
												</div>
												<div
													class="invalid-feedback"
													v-if="!$v.gender.required"
												>
													ورود جنسیت الزامی است
												</div>
											</div>
										</div>
									</div>

									<!-- job class & job-->
									<div class="row justify-content-between">
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.jobclass") }}</label
												>
												<select
													class="form-control form-control-sm"
													id="jobclass"
													v-model.trim="$v.jobClass.$model"
													:class="{ 'is-invalid': $v.jobClass.$error }"
												>
													<option value="0">{{ $t("register.staff") }}</option>
													<option value="1">{{
														$t("register.selfEmployment")
													}}</option>
													<option value="2">{{
														$t("register.pensioner")
													}}</option>
												</select>
												<div
													class="invalid-feedback"
													v-if="!$v.jobClass.required"
												>
													حوزه شغلی خود را وارد کنید
												</div>
											</div>
										</div>

										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.job") }}</label
												>
												<input
													id="job"
													type="text"
													v-model.trim="$v.job.$model"
													class="form-control"
													:class="{ 'is-invalid': $v.job.$error }"
													@blur="$v.job.$touch()"
												/>
												<div class="invalid-feedback" v-if="!$v.job.$required">
													عنوان شغلی خود را وارد کنید
												</div>
												<small id="" class="form-text text-danger">{{
													$t("register.jobDanger")
												}}</small>
											</div>
										</div>
									</div>

									<!-- INCOME &  -->
									<div class="row justify-content-between">
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.income") }}</label
												>

												<vue-numeric
													id="income"
													separator=","
													v-model.trim="$v.income.$model"
													class="form-control"
													:class="{ 'is-invalid': $v.income.$error }"
													@blur="$v.income.$touch()"
												></vue-numeric>
												<div
													class="invalid-feedback"
													v-if="!$v.income.required"
												>
													حدود درآمد را وارد کنید
												</div>
												<div
													class="invalid-feedback"
													v-if="!$v.income.minValue"
												>
													حدود درآمد را صحیح وارد کنید
												</div>
												<div
													class="invalid-feedback"
													v-if="!$v.income.maxValue"
												>
													حدود درآمد را به میلیون ریال وارد کنید
												</div>
											</div>
										</div>
									</div>
									<!-- SELECT LEVEL -->
									<div class="row">
										<div class="col-md-5 font-size--15">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.selectLevel") }}</label
												>
												<form class="form">
													<div class="form-check">
														<input
															class="form-check-input"
															type="radio"
															name="exampleRadios"
															id="exampleRadios1"
															value="1"
															v-model="level"
															checked
														/>
														<label
															class="form-check-label"
															for="exampleRadios1"
														>
															{{ $t("setLevel.level1") }}
														</label>
													</div>
													<div class="form-check">
														<input
															class="form-check-input"
															type="radio"
															name="exampleRadios"
															id="exampleRadios2"
															value="2"
															v-model="level"
														/>
														<label
															class="form-check-label"
															for="exampleRadios2"
														>
															{{ $t("setLevel.level2") }}
														</label>
													</div>
													<div class="form-check">
														<input
															class="form-check-input"
															type="radio"
															name="exampleRadios"
															id="exampleRadios3"
															value="3"
															v-model="level"
														/>
														<label
															class="form-check-label"
															for="exampleRadios3"
														>
															{{ $t("setLevel.level3") }}
														</label>
													</div>
												</form>
											</div>
										</div>
									</div>

									<!-- CUSTOMER TYPE -->
									<div class="row justify-content-between">
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.costomerType") }}</label
												>
												<select
													class="form-control form-control-sm"
													:class="{ 'is-invalid': $v.is_organ.$error }"
													id="costomerType"
													v-model.trim="$v.is_organ.$model"
												>
													<option value="true">سازمانی</option>
													<option value="false">آزاد</option>
												</select>
												<div
													class="invalid-feedback"
													v-if="!$v.is_organ.required"
												>
													نوع کاربری را وارد نمایید
												</div>
											</div>
										</div>

										<div class="col-md-5">
											<div class="form-group" v-if="is_organ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.organizationCode") }}</label
												>
												<input
													id="organizationCode"
													type="text"
													v-model="organizationCode"
													class="form-control"
													required
												/>
											</div>
										</div>
									</div>
								</div>
								<!-------------------------------------     address  ------------------------------------------->
								<hr />
								<h4 class="text-dark text-align-center">
									{{ $t("register.addressInfo") }}
								</h4>
								<br />

								<!-- ADRESS -->
								<div class="form-row justify-content-between">
									<div class="col">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.province") }}</label
											>
											<input
												id="province"
												type="text"
												v-model.trim="$v.province.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.province.$error }"
												@blur="$v.province.$touch()"
											/>
											<div
												class="invalid-feedback"
												v-if="!$v.province.required"
											>
												ورود استان لازم است
											</div>
										</div>
									</div>

									<div class="col">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.city") }}</label
											>
											<input
												id="city"
												type="text"
												v-model.trim="$v.city.$model"
												:class="{ 'is-invalid': $v.city.$error }"
												class="form-control"
												style="radius=10px"
												@blur="$v.city.$touch()"
											/>
											<div class="invalid-feedback" v-if="!$v.city.required">
												ورود شهر لازم است
											</div>
										</div>
									</div>
									<div class="col-md-8">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.address") }}</label
											>
											<textarea
												id="address"
												type="text"
												v-model.trim="$v.address.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.address.$error }"
												@blur="$v.address.$touch()"
											/>
											<div class="invalid-feedback" v-if="!$v.address.required">
												ورود آدرس لازم است
											</div>
										</div>
									</div>
								</div>

								<!-- ZIP CODE -->
								<div class="form-row">
									<div class="col-md-4">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.zipCode") }}</label
											>

											<tooltip
												effect="scale"
												trigger="click"
												placement="top"
												content=" برای دریافت کد پستی خودمی توانید به سامانه
												<span
													><a
														href='https://epostcode.post.ir/'
														target='_blank'
														rel='noopener noreferrer'
														>کد پستی</a
													></span
												>
												مراجعه کنید ."
											>
												<a class="popover_btn">
													راهنما
												</a>
											</tooltip>

											<input
												id="zipCode"
												type="number"
												@wheel="$event.target.blur()"
												v-model.trim="$v.zipCode.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.zipCode.$error }"
												@blur="$v.zipCode.$touch()"
											/>
											<div class="invalid-feedback" v-if="!$v.zipCode.required">
												{{ $t("customerData.Errors.postalcode required") }}
											</div>
											<div
												class="invalid-feedback"
												v-if="!$v.zipCode.checkZipcode"
											>
												{{ $t("customerData.Errors.postalcode.notEnvalid") }}
											</div>
										</div>
									</div>
								</div>
								<br />
								<br />
								<div
									class="d-flex justify-content-between align-items-center flex-column"
								>
									<button
										class="btn btn-bg--primary btn-size--md btn-hover--3d"
										type="submit"
										@click.prevent="updateCostumer"
									>
										<span class="btn__text">ثبت</span>
									</button>
								</div>
							</form>
							<!-- end of form -->
						</div>
						<!-- end of from area -->
					</div>
					<!-- end of col -->
				</div>
				<!-- end of row -->
			</div>
			<!-- end of container -->

			<!-- =========== End of Body ============ -->
		</section>
	</div>
</template>

<script>
//import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueNumeric from "vue-numeric";
// import { popover } from "vue-strap";
import { tooltip } from "vue-strap";
import { supplierCustomerValidationMixin } from "../../mixins/validationMixin";
export default {
	props: ["id"],
	data() {
		return {
			alert: false,
			errors: [],

			customer_id: "",
			name: "",
			lastName: "",
			fatherName: "",
			melliCode: "",
			gender: "",
			level: "",
			jobClass: "",
			job: "",
			is_organ: false,
			organizationCode: "",
			income: "",
			mobile: "",
			phone: "",
			province: "",
			city: "",
			address: "",
			zipCode: "",
			organShow: false,
		};
	},
	mixins: [supplierCustomerValidationMixin],
	mounted() {
		this.createCostumer();
	},
	computed: {
		isOrgan() {
			return this.is_organ;
		},
	},
	methods: {
		organization() {
			if (this.is_organ) {
				this.organShow = true;
				return this.organShow;
			}
			return this.organShow;
		},
		createCostumer() {
			let customer_data = {
				user: this.id,
			};
			this.$store
				.dispatch("addCustomer", customer_data)
				.then((resp) => {
					console.log(resp);
					this.customer_id = resp.body.id;
					// .$store.commit("setFirstName", resp.body.user.first_name);
				})
				.catch((err) => {
					console.log(err);
					this.$noty.errors("مشکلی در ساخت کاربر پیش‌ آمده است");
				});
		},
		updateCostumer() {
			const customer_data = {
				customerID: this.customer_id,
				user: {
					first_name: this.name,
					last_name: this.lastName,
					melli_code: this.melliCode,
					father_name: this.fatherName,
					phone_number: this.phone,
					// workplace_number: this.phone,

					province: this.province,
					city: this.city,
					address: this.address,
					gender: this.gender,
				},

				level: this.level,
				job_class: this.jobClass,
				job: this.job,
				estimate_income: this.income,
				postal_code: this.zipCode,
			};
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.submitStatus = "ERROR";
				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				this.$store
					.dispatch("updateSuppliersCustomer", customer_data)
					.then((response) => {
						console.log(response);
						this.$router.push(
							"/supplier/customers/" + this.customer_id + "/docs",
						);
						load.hide();
					})
					.catch((err) => {
						console.log(err);
						this.alert = true;
						this.errors = err.body;
						this.$noty.error("مشکلی پیش‌ آمده است");
						load.hide();
					});
			}
		},
	},
	// validations: {
	// 	melliCode: {
	// 		required,
	// 		checkMelliCode(code) {
	// 			if (
	// 				!/^\d{10}$/.test(code) ||
	// 				code == "0000000000" ||
	// 				code == "1111111111" ||
	// 				code == "2222222222" ||
	// 				code == "3333333333" ||
	// 				code == "4444444444" ||
	// 				code == "5555555555" ||
	// 				code == "6666666666" ||
	// 				code == "7777777777" ||
	// 				code == "8888888888" ||
	// 				code == "9999999999"
	// 			)
	// 				return false;
	// 			var check = parseInt(code[9]);
	// 			var sum = 0;
	// 			var i;
	// 			for (i = 0; i < 9; ++i) {
	// 				sum += parseInt(code[i]) * (10 - i);
	// 			}
	// 			sum %= 11;
	// 			return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
	// 		},
	// 	},
	// 	name: {
	// 		required,
	// 	},
	// 	lastName: {
	// 		required,
	// 	},
	// 	fatherName: {
	// 		required,
	// 	},
	// 	phone: {
	// 		required,
	// 		minLength: minLength(11),
	// 		maxLength: maxLength(11),
	// 	},
	// 	province: {
	// 		required,
	// 	},
	// 	city: {
	// 		required,
	// 	},
	// 	address: {
	// 		required,
	// 	},
	// 	job: {
	// 		required,
	// 	},
	// 	jobClass: {
	// 		required,
	// 	},
	// 	income: {
	// 		required,
	// 		minValue: minValue(10000000),
	// 	},
	// 	zipCode: {
	// 		required,
	// 		minLength: minLength(10),
	// 		maxLength: maxLength(10),
	// 	},
	// 	is_organ: {
	// 		required,
	// 	},
	// 	level: {
	// 		required,
	// 	},
	// 	gender:{
	// 		required
	// 	}
	// },
	components: {
		VueNumeric,

		tooltip,
	},
};
</script>

<style scoped>
.vpd-icon-btn {
	display: flex;
	width: 1%;
	cursor: pointer;
	padding: 0 10px;
}
.popover_btn {
	background-color: rgb(189, 192, 189);
	border-radius: 50%;
	border: none;
	color: #000000;
	padding: 10px;
	text-align: center;
	text-decoration: none;
	display: inline-block;
	font-size: 12px;
	margin: 4px 6px;
}
</style>
